import request from '@/utils/http';

// 发车单防串货预警分页查询接口
export const queryByPage = data => {
    return request({
        url: '/api-antms/query/preventBunchGoodsWarning/queryByPage',
        method: 'post',
        data
    });
};

// 发车单防串货预警查询数量接口
export const queryCount = data => {
    return request({
        url: '/api-antms/query/preventBunchGoodsWarning/queryCount',
        method: 'post',
        data
    });
};

// 取消发车单防串货预警接口
export const cancelPreventBunchGoodsWarning = data => {
    return request({
        url: '/api-antms/transport/dispatchLcl/cancelPreventBunchGoodsWarning',
        method: 'post',
        data
    });
};

// 取消发车单防串货预警接口
export const createTmsAdvice = data => {
    return request({
        url: '/api-antms/transport/dispatchLcl/createTmsAdvice',
        method: 'post',
        data
    });
};

// 在途预警分页查询接口
export const queryMonitorByPage = data => {
    return request({
        url: '/api-antms/query/dispatch/changeMonitor/queryByPage',
        method: 'post',
        data
    });
};

// 在途预警查询数量接口
export const queryMonitorCount = data => {
    return request({
        url: '/api-antms/query/dispatch/changeMonitor/queryCount',
        method: 'post',
        data
    });
};

// 串货预警-预警处理-列表分页查询
export const queryMonitorDealByPageApi = data => {
    return request({
        url: '/api-antms/query/dispatch/changeMonitorDeal/queryByPage',
        method: 'post',
        data
    });
};

// 串货预警-预警处理-查询列表数量接口
export const queryMonitorDealCountApi = data => {
    return request({
        url: '/api-antms/query/dispatch/changeMonitorDeal/queryCount',
        method: 'post',
        data
    });
};

// 防串货在途预警-预警处理弹窗-查询出同一发车单下未处理的同一预警类型的全部数据
export const queryWarningDataByTypeApi = params => {
    return request({
        url: '/api-antms/query/dispatchChangeMonitor/queryWarningDataByType',
        method: 'get',
        params
    });
};
